import {NgModule} from '@angular/core';
import {BytesTransformPipe} from './bytes-transform.pipe';
import {CommonModule} from '@angular/common';
export class CbjPipesModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    BytesTransformPipe
  ],
  exports: [
    BytesTransformPipe
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjPipesModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjPipesModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjPipesModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
